export const MB2Bytes = (MegaByte: number) => {
  return MegaByte * 1024 * 1024;
};
